// Adyen HMAC key rotation happens entirely on the hotel's own Adyen Customer Area — we only
// find out once the admin pastes the new value into this form. Adyen also documents that a
// freshly generated HMAC key can take some time to propagate through their infrastructure, so
// notifications may still arrive signed with the old key for a while after the rotation. The
// backend (AdyenPaymentOrchestrator#verifyNotificationSignature in wb-payments-sls) accepts a
// notification signed with either `hmacKey` or `hmacKeyPrevious` to cover that window.
//
// This only moves the stored key into `hmacKeyPrevious` when the admin actually entered a
// different value than what was last persisted, so re-saving the form with the same hmacKey
// (or saving with the field left blank) never clobbers an already-rotated `hmacKeyPrevious`
// with the current key.
function resolveAdyenHmacKeyPrevious({ previousProperties, formValues }) {
  const previousHmacKey = previousProperties?.hmacKey;
  const nextHmacKey = formValues.hmacKey;

  if (nextHmacKey && previousHmacKey && nextHmacKey !== previousHmacKey) {
    return previousHmacKey;
  }

  return previousProperties?.hmacKeyPrevious;
}

export { resolveAdyenHmacKeyPrevious };
